import React, {useState, useEffect, useRef} from 'react'
import '../styles/AlfLoading.css'
import Orb2 from '../images/Orb2.png'
// import Orb4 from '../images/Orb4.png'
import Orb5 from '../images/Orb5.png'

export default function AlfLoading() {
  const [ellipsis, _setEllipsis] = useState(0)
  const ellipsisRef = useRef(ellipsis)
  function setEllipsis(data) {
    ellipsisRef.current = data
    _setEllipsis(data)
  }

  let interval
  useEffect(() => {
    if (!interval) {
      interval = setInterval(() => {
        setEllipsis(ellipsisRef.current + 1)
        // console.log('Here: ', ellipsisRef.current)
      }, 1000)
    }
  }, [])

  return (
    <div id='alf-loading-container'>
      <div
        id='backdrop'
      />
      <div id='alf-loading-content'>
        <div
          id='alf-loading'
        >
          {/* <img
            style={{position: 'absolute'}}
            src={Orb4}
            className='orb'
          /> */}
          <img
            style={{position: 'absolute'}}
            src={Orb2}
            className='orb-anim-1'
          />
          <img
            style={{position: 'absolute'}}
            src={Orb5}
            className='orb-anim-2'
          />
        </div>
        <div className='loading-text'>
          <div className='loading-text-content'>
            <span id='one-m-p'>One Moment Please</span>
            <span>
              {Array.from(Array(ellipsis % 4).keys())
                  .map((num) => <span key={num}>{'.'}</span>)
              }
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
